<div class="card mt-1">
  <div class="card-body">
    <h4>Audit</h4>
    @if (!processing) {
      <div>
        @if (capture.userAuditOutcome) {
          <strong>Audit Outcome</strong>
          <p>
            {{ capture.userAuditOutcome.status | captureUserAuditOutcomeStatus }}
          </p>
          @if (capture.userAuditOutcome.statusReasons && capture.userAuditOutcome.statusReasons.length > 0 ) {
            <div>
              <strong>Reasons</strong>
              <p>
                {{ capture.userAuditOutcome.statusReasons | captureUserAuditOutcomeStatusReasons }}
              </p>
            </div>
          }
          @if (capture.userAuditOutcome.note) {
            <div>
              <strong>Audit Note</strong>
              <p>
                {{ capture.userAuditOutcome.note }}
              </p>
            </div>
          }
          <div class="row">
            <div class="col-2">
              <strong>Audited By</strong>
              <div>
                {{ capture.userAuditOutcome.auditingUser.email }}
              </div>
            </div>
            <div class="col-2">
              <strong>Audited On</strong>
              <div>
                {{ capture.userAuditOutcome.createdAt | date: 'MM/dd/yyyy' }}
              </div>
            </div>
          </div>
        } @else {
          @if (canAudit) {
            <form (ngSubmit)="onSubmit()">
              @if (serverErrorMessage) {
                <div class="alert-danger text-danger p-1 mb-2">
                  An error occurred while saving this audit: {{ serverErrorMessage }}
                </div>
              }
              <label>Audit Outcome</label>
              <div class="d-flex align-items-center">
                <div class="mb-3 w-50 me-2">
                  <select class="form-select" [(ngModel)]="formModel.status" name="status" (change)="onFormControlChange()">
                    <option [ngValue]="null" [selected]="true"> -- Select Outcome -- </option>
                    @for (outcomeStatusOption of availableOutcomeStatusOptions; track outcomeStatusOption) {
                      <option [ngValue]="outcomeStatusOption.value">
                        {{ outcomeStatusOption.display }}
                      </option>
                    }
                  </select>
                </div>
                <div class="mb-3">
                  <button class="btn btn-primary" type="submit" [disabled]="!allowSubmit">
                    Save Outcome
                  </button>
                </div>
              </div>
              @if (formModel.status === captureUserAuditOutcomeStatus.noncompliant || formModel.status === captureUserAuditOutcomeStatus.compliantWithMinorFindings) {
                <div>
                  <label>Select Reasons(s)</label>
                  <span>
                    (Required)
                  </span>
                  @for (outcomeStatusReasonOption of availableOutcomeStatusReasonOptions; track outcomeStatusReasonOption) {
                    <div>
                      <label>
                        <input type="checkbox"
                          value=""
                          [id]="'status_reason_' + outcomeStatusReasonOption.value"
                          [name]="'status_reason_' + outcomeStatusReasonOption.value"
                          (change)="onFormControlChange()"
                          [(ngModel)]="formModel.statusReasons[outcomeStatusReasonOption.value]" />
                        {{ outcomeStatusReasonOption.display }}
                      </label>
                    </div>
                  }
                </div>
              }
              <label>
                Audit Note
                @if (formModel.status === captureUserAuditOutcomeStatus.noncompliant || formModel.status === captureUserAuditOutcomeStatus.compliantWithMinorFindings) {
                  <span>
                    (Required)
                  </span>
                }
              </label>
              <textarea [(ngModel)]="formModel.note" name="note" class="form-control w-50" (keyup)="onFormControlChange()"></textarea>
            </form>
          } @else {
            Capture has not been audited.
          }
        }
      </div>
    } @else {
      <div class="py-2">
        <fa-icon [icon]="['fas', 'circle-notch']" size="sm" [animation]="'spin'" />
        Saving audit...
      </div>
    }
  </div>
</div>



